<template>
  <div class="entrustNow">
    <el-row class="entrustNowHeader">
      <el-col :span="20">
        <!-- <el-select v-model="isFilterFailOrder" placeholder="是否过滤无效单" size="small">
          <el-option v-for="item in options" :key="item.value" :value="item.value" :label="item.label">
          </el-option>
        </el-select> -->
        <el-select v-model="isFilterOperate" size="small">
          <el-option v-for="item in ValueOptions" :key="item.value" :value="item.value" :label="item.label">
          </el-option>
        </el-select>
      </el-col>
      <el-col :span="4" align="right">
        <!-- <el-button type="primary" size="small" @click="dialogShowFields = true" :disabled="!id">编辑</el-button> -->
      </el-col>
    </el-row>
    <!-- <el-table :data="datas" border :height="200" style="width: 100%;" highlight-current-row :row-class-name="statusClass"  v-if="isLoad"> -->
    <el-table :data="datas" border :height="height" style="width: 100%;" highlight-current-row :row-class-name="statusClass" @row-dblclick="Revoke">
      <!-- <el-table-column prop="orderNo" label="委托编号"> </el-table-column>
      <el-table-column prop="subAccountNo" label="子账业务" :formatter="changeSubNo"> </el-table-column>
      <el-table-column prop="exchange" label="交易所"> </el-table-column>
      <el-table-column prop="underlying" label="标的代码"> </el-table-column>
      <el-table-column prop="orderVolume" label="委托数量(手)"> </el-table-column>
      <el-table-column prop="orderPrice" label="委托价"> </el-table-column>
      <el-table-column label="最新价" :formatter="newPrice"> </el-table-column>
      <el-table-column prop="tradeVolume" label="成交数量"> </el-table-column>
      <el-table-column label="委托挂单数量" :formatter="guadan"> </el-table-column>
      <el-table-column prop="tradeValue" label="成交金额"> </el-table-column>
      <el-table-column label="场外开平方向">
        <template slot-scope="scope">
          <span> {{ scope.row.openClose == "O"?"开":"平" }} </span>
        </template>
      </el-table-column>
      <el-table-column label="买卖方向">
        <template slot-scope="scope">
          <span> {{ scope.row.buySell == "B"?"买":"卖" }} </span>
        </template>
      </el-table-column>
      <el-table-column label="委托来源">
        <template slot-scope="scope">
          <span> {{ scope.row.sourceType == '0'?'电话接单':'web来单' }} </span>
        </template>
      </el-table-column>
      <el-table-column label="委托状态">
        <template slot-scope="scope">
          <span> {{ changeStatus(scope.row.status) }} </span>
        </template>
      </el-table-column>
      <el-table-column label="下单时间">
        <template slot-scope="scope">
          <span> {{ scope.row.webCreateTimeValue }} </span>
        </template>
      </el-table-column>
      <el-table-column label="结算日期">
        <template slot-scope="scope">
          <span> {{ changeTime(scope.row.expiringDate) }} </span>
        </template>
      </el-table-column> -->
      <el-table-column v-for="item in showFields" :key="item.value" :prop="item.value" :label="item.key" show-overflow-tooltip :width="widths[item.value]"> </el-table-column>
      <el-table-column label="操作" v-if="!dis">
        <template slot-scope="scope">
          <div>
            <el-button type="danger" size="mini" @click="open(scope.row.orderNo)" :disabled="scope.row.status < 0 || scope.row.status == 3">撤单</el-button>
          </div>
        </template>
      </el-table-column>
      <!-- <el-table-column prop="statusMsg" label="错误信息" width="200" :formatter="errorMsg"></el-table-column> -->
    </el-table>

    <el-dialog title="改变显示字段" :visible.sync="dialogShowFields" :before-close="beforeClose">
      <el-transfer v-model="showValue" :data="allFields" @left-check-change="leftChange" @right-check-change="rightChange" target-order="push" :titles="['所有字段', '需显示字段']"></el-transfer>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" size="mini" @click="enter">设置</el-button>
        <el-button type="primary" size="mini" @click="beforeClose">取消</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import axios from '@/axios'
  import $ from 'jquery'
  import g from '@/components/Global.vue'
  import bus from '@/assets/eventBus'
  export default {
    name: 'for_entrustNow',
    data() {
      return {
        sub: '',
        id: '',
        user: '',
        dis: false,

        tableData: [],
        // sockets: [],
        beginDate: '',
        endDate: '',
        orderNo: '',    //用于存储由于交易密码token失效重新验证后自己撤单所用的数据

        // 页码
        page: 1,
        total: 100,
        pageSize: 100,

        entexpands: [], //用于实现点击整行显示数据
        widths: [], //用于存放根据浏览器窗口大小改变宽度
        daochudisabled: true,
        isFilterFailOrder: 0,
        isFilterOperate: 0,
        filterFlag: false,
        

        // 转化数据
        options: [{
            value: 0,
            label: "包含无效单"
          },
          {
            value: 1,
            label: "不包含无效单"
          },
        ],
        ValueOptions: [{
          value: 0,
          label: "查看全部委托"
        }, {
          value: 1,
          label: "只查看可操作委托单"
        }],
        offsetFlagOptions: [{
            value: 0,
            label: "开仓"
          },
          {
            value: 1,
            label: "平仓"
          },
          {
            value: 3,
            label: "平今"
          }
        ],
        hedgeFlagOptions: [{
            value: 1,
            label: "投机"
          },
          {
            value: 2,
            label: "套利"
          },
          {
            value: 3,
            label: "套保"
          },
          {
            value: 4,
            label: "备兑"
          }
        ],
        marginTypeOptions: [ //保证金类型+
          {
            value: 0,
            label: "普通保证金类型"
          },
          {
            value: 1,
            label: "特别保证金类型"
          },
          {
            value: 2,
            label: "上海筑欣类型"
          },
          {
            value: 3,
            label: "大商所优化保证金"
          },
          {
            value: 4,
            label: "Delta保证金"
          },
          {
            value: 5,
            label: "权益类期权保证金"
          },
        ],

        // 切换显示的字段
        dialogShowFields: false,
        showValue: [],    //穿梭框显示的字段集合
        allFields: [    //穿梭框全部字段集合
          {value: 'orderNo', key: '委托编号'},
          {value: 'subAccountName', key: '子账业务'},
          {value: 'exchange', key: '交易所'},
          {value: 'underlying', key: '标的代码'},
          {value: 'orderVolume', key: '委托数量(手)'},
          {value: 'orderPrice', key: '委托价'},
          {value: 'newPrice', key: '最新价'},
          {value: 'tradeVolume', key: '成交数量'},
          {value: 'guadanValue', key: '委托挂单数量'},
          {value: 'tradeValue', key: '成交金额'},
          {value: 'openCloseValue', key: '场外开平方向'},
          {value: 'buySellValue', key: '买卖方向'},
          {value: 'sourceTypeValue', key: '委托来源'},
          {value: 'statusValue', key: '委托状态'},
          {value: 'webCreateTimeValue', key: '下单时间'},
          {value: 'expiringDateValue', key: '结算日期'},
          {value: 'errorMsg', key: '错误信息'},
        ],    
        showFields: [],    //显示在界面上的数组集合

        isLoad: true,
        widths: {
          orderNo: 80,
          subAccountName: 100, 
          exchange: 80,
          underlying: 80,
          orderVolume: 80,
          orderPrice: 110,
          newPrice: 110,
          tradeVolume: 80,
          guadanValue: 80,
          tradeValue: 110,
          openCloseValue: 80,
          buySellValue: 80,
          sourceTypeValue: 80,
          statusValue: 140,
          webCreateTimeValue: 170,
          expiringDateValue: 100,
          errorMsg: 100,
        },
      }
    },
    created() {
      bus.$on('retryRepeal', this.retryRepeal)
      bus.$on("daochuEntrustNow", this.daochu)
      bus.$on("compileEntrustNow", this.openDialog)  
      // bus.$on('sockets', this.getSockets)
    },
    destroyed() {

    },
    beforeDestroy() {
      bus.$off('retryRepeal')
      bus.$off("daochuEntrustNow")
      bus.$off("compileEntrustNow")  
    },
    computed: {
      sockets() {
        return this.$store.state.sockets
      },
      datas() {
        if(this.isFilterOperate) {
          return this.tableData.filter( item => item.status >= 0 && item.status != 3) 
        } else {
          return this.tableData
        }
      },
    },
    methods: {
      // getSockets(sockets) {
      //   this.sockets = sockets
      // },
      daochu() {
        this.postDown(`${g.baseURL}client/forward/excel/exportCurrentTradingDayForwardOrderLogs.do`, {
          'clientBindId': this.id,
          'subAccountNos[]': this.sub,
          'isFilterFailOrder': this.isFilterFailOrder,
        })
      },
      Revoke(row) {
        if(row.status < 0 || row.status == 3) return 
        this.open(row.orderNo)
      },
      open(no) {
          this.$confirm('此操作将撤销该笔订单, 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            this.repeal(no)
          }).catch(() => {
            this.$message({
              type:"warning",
              message:"已取消",
              showClose: true
            })
          });
        },
      // 撤单
      repeal(no) {
        this.orderNo = ''
        let orderNo = no
        let clientBindId = this.id
        return new Promise((reslove, reject) => {
          axios.post('client/forward/forwardorderlog/requestCancelOrder.do', this.qs.stringify({
            orderNo,
            clientBindId,
            tradeToken: window.sessionStorage.getItem("token")
          })).then(result => {
            if (result == 'token') {
              let obj = {
                id: this.id,
                type: 'repeal'
              }
              bus.$emit("checkPass", obj)
            }
            if (result.data.success) {
              this.$message({
                type: "success",
                message: "撤单请求已发送",
                showClose: true,
              })
              if (result.data.FORWARD_TRADE_TOKEN) {
                window.sessionStorage.setItem("token", result.data.FORWARD_TRADE_TOKEN)
              }

              reslove()
            }

          })
        })
      },
      // 重复之前的撤单操作
      retryRepeal(){
        this.repeal(this.orderNo)
      },
      handleClose() {
        this.dialogVisible = false
      },

      // 改变显示的字段
      getShowFields() {   //获取显示的字段
        this.isLoad = false
        axios.post("client/queryClientForwardFieldInformation.do", this.qs.stringify({
          clientBindId: this.id, 
          businessType: 0,
        })).then(result => {
          if(result.data.success) {
            let datas = JSON.parse(result.data.fieldInformation)
            if(datas && datas.length) {
              this.showFields = datas
              this.isLoad = true
            } else {
              this.showFields = this.allFields
              this.isLoad = true
            }
          }
        }).catch(err => {
          this.isLoad = true
        })
      },
      enter() {
        let arr = []
        this.showValue.forEach(list => {
          this.allFields.forEach(item => {
            if(list === item.key) {
              arr.push(item)
            }
          })
        })
        axios.post("client/addClientForwardFieldInformation.do", this.qs.stringify({
          clientBindId: this.id,
          businessType: 0,
          fieldInformation: JSON.stringify(arr)
        })).then(result => {
          if(result.data.success) {
            this.$message.success("设置成功")
            this.getShowFields()
          }
        })

        // let datas = this.clone(this.tableFields)
        // datas.entrustNow = arr
        // bus.$emit("changeFields", datas)
        this.beforeClose()
      },

      beforeClose() {
        this.showValue = []
        this.dialogShowFields = false
      },
      leftChange(arr) {
        this.showValue = [...this.showValue, ...arr]
      },
      rightChange(arr) {
        arr.forEach(list => {
          for(let i = 0; i < this.showValue.length; i++) {
            if(list === this.showValue[i]) {
              this.showValue.splice(i, 1)
            }
          }
        })
      },

      openDialog() {
        let arr = []
        this.showFields.forEach(item => {
          arr.push(item.key)
        })
         this.showValue = arr
        this.dialogShowFields = true
      },
      
      // 处理表格状态切换class类名，改变单元行颜色
      statusClass({row}){
        if(row.status > 0 ) {
          if(row.buySell == 'B') {
            return 'buy-row'
          } else {
            return 'sell-row'
          }
        } else if(row.status < 0) {
          return 'err-row'
        }
      },
      // 处理表单数据
      changeTime(val) {
        return this.timeFormat(new Date(val), "-")
      },
      direction(open, buy) {
        let o = open == "O" ? "开" : "平"
        let b = buy == "B" ? "买" : "卖"
        return b + o
      },
      changeoffsetFlag(val) {
        let str = ''
        this.offsetFlagOptions.forEach(item => {
          if (item.value == val) {
            str = item.label
          }
        })
        return str
      },
      changehedgeFlag(val) {
        let str = ''
        this.hedgeFlagOptions.forEach(item => {
          if (item.value == val) {
            str = item.label
          }
        })
        return str
      },
      changeMarginType(val) {
        let str = ''
        this.marginTypeOptions.forEach(item => {
          if (item.value == val) {
            str = item.label
          }
        })
        return str
      },
      newPrice(obj) {
        let underlying = obj.underlying
        let exchange = obj.exchange
        let price = ''
        this.sockets.forEach(item => {
          if(item.exchange_id == exchange && item.instrument_id == underlying) {
            price = item.price
          }
        })
        return price
      },
      guadan(obj) {
        return obj.orderVolume - obj.tradeVolume
      },
      changeStatus(val) {
        let str = ''
        switch (val) {
          case 0:
            str = '委托正常（未报入）'
            break;
          case -1:
            str = '失效'
            break;
          case -2:
            str = '场内下单失败'
            break;
          case -2:
            str = '场内下单失败'
            break;
          case -3:
            str = '完全撤单'
            break;
          case -4:
            str = '部成部撤'
            break;
          case 1:
            str = '未完成'
            break;
          case 2:
            str = '报入'
            break;
          case 3:
            str = '完全成交'
            break;
          case 4:
            str = '部分成交'
            break;
          case 5:
            str = '等待撤单'
            break;
        }
        return str
      },
      changeSubNo(obj) {
        let arr = this.subNos.filter(item => item.subAccountNo == obj.subAccountNo )
        return arr[0].subAccountBusinessName
      },
      errorMsg(obj) {
        if(obj.orderNo) {
          return obj.status >= 0?'':obj.statusMsg
        } else {
          return obj.failInfo
        }
      }
    },

    watch: {
      $route: {
        handler(to, from) {
          this.dis = to.query.dis
          let user = to.query.user
          let id = to.query.id
          let sub = to.query.sub
          if ( to.path == '/newLayoutForword' && user && id && sub) {
            this.sub = to.query.sub
            this.id = to.query.id
            this.user = to.query.user
            this.showFields = this.allFields
            this.getShowFields()
          } else {
            // this.tableData = []
          }
        },
        immediate: true
      },
      tableData(newValue, oldValue) {
        if (newValue.length > 0) {
          this.daochudisabled = false
          bus.$emit("changeEntrustFlag", false)
        } else {
          this.daochudisabled = true
          bus.$emit("changeEntrustFlag", true)
        }
      },
      showData: {
        handler(newValue, oldValue) {
          this.tableData = this.clone(newValue)
          this.tableData.sort( function(x, y) { if(x.orderNo > y.orderNo) { return -1 } if(x.orderNo < y.orderNo) { return 1 } return 0 })
          this.tableData.forEach(item => {
            this.$set(item, 'subAccountName', this.changeSubNo(item))
            this.$set(item, 'newPrice', this.newPrice(item))
            this.$set(item, 'guadanValue', this.guadan(item))
            this.$set(item, 'openCloseValue', item.openClose == "O"?"开":"平")
            this.$set(item, 'buySellValue', item.buySell == "B"?"买":"卖")
            this.$set(item, 'sourceTypeValue', item.sourceType == '0'?'电话接单':'web来单')
            this.$set(item, 'statusValue', this.changeStatus(item.status))
            // this.$set(item, 'webCreateTimeValue', item.createTime)
            this.$set(item, 'webCreateTimeValue', item.webCreateTime ? item.webCreateTime : item.createTime)
            this.$set(item, 'expiringDateValue', item.expiringDate)
            this.$set(item, 'errorMsg', this.errorMsg(item))
          })
        },
        immediate: true
      },
      subNos: {
        handler(newValue, oldValue) {
          if(!newValue.length) return
          this.tableData.forEach(item => {
            this.$set(item, 'subAccountName', this.changeSubNo(item))
          })
        },
        immediate: true
      },
    },
    props: ['subNos', "showData", 'height']
  }

</script>

<style>
.sell-row {
  background: #acf2c6 !important;
}
.buy-row {
  background: #f49a9a !important;
}
.err-row {
  background: #999 !important;
}
.entrustNowHeader {
  height: 32px;
}
td {
  padding: 0 !important;
}
.entrustNow th {
  padding: 0 !important;
}
</style>
